import './App.css';
import SignIn from './components/sign-in/sign-in';
import Home from './components/home/home.jsx'
import { FirebaseProvider } from './components/firebase/context';
import firebase from 'firebase'
import { BrowserRouter as Router, Route, Switch, useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import LandingPage from './components/landing/landing';

var firebaseConfig = {
  apiKey: "AIzaSyB9Ka-CuYltt2zyGNT2kNNH6-4KRc5nuew",
  authDomain: "se-tech-exercise.firebaseapp.com",
  projectId: "se-tech-exercise",
  storageBucket: "se-tech-exercise.appspot.com",
  messagingSenderId: "401668067117",
  appId: "1:401668067117:web:56344904f7224b7c160da4",
  measurementId: "G-FR8KYMBZK4"
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#1b2731",
    },
    secondary: {
      main: "#253343",
    },
    red: {
      main: '#FF0000'
    }
  },
  typography: {
    fontFamily: '"Open Sans",sans-serif'
  }
});

function App() {
  const history = useHistory();

  // a app-level boolean to prevent the rest of the app rendering until we initialize firebase
  const [fbInit, setFbInit] = useState(false);

  const initFb = () => {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        const auth = firebase.auth();
        auth.useEmulator("http://localhost:9099");
        

        firebase.firestore().settings({
          host: 'localhost:8080',
          ssl: false
        })



        firebase.functions().useEmulator('localhost', 5001);
      }

      //store user data for QM events
      firebase.auth().onAuthStateChanged(user => {
        window.qmData = Object.assign({}, window.qmData, { user: user })
      }
      )
    }

    setFbInit(true);
  }

  const setCookie = () => {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = 'se_test' + "=" + ('chocolate_chip' || "") + expires + "; path=/";
  }

  const setDataLayer = () => {
    window.dataLayer = {
      brand: "Quantum Metric",
      platform: 'Firebase & React',
      errors: [],
      environment: 'prod',
      page_type: 'exercise',
      warnings: [
        {
          message: "These aren't the droids you're looking for. Move along. Move along."
        },
        {
          message: "Danger, Will Robinson. Danger!"
        }
      ]
    }
  }

  useEffect(() => {
    initFb();
    setCookie();
    setDataLayer();
  }, [])

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        {fbInit ?
          <FirebaseProvider value={firebase}>
            <Router>
              <Switch>
                <Route exact path="/" component={LandingPage} title="Exercise Home" />
                <Route exact path="/:role/exercise/:step" component={Home} title="Exercise Step" />
                <Route exact path={["/:role/signin", "/:role"]} component={SignIn} title="Sign In" />
              </Switch>
            </Router>
          </FirebaseProvider> : ""
        }
      </ThemeProvider>

    </div>
  );
}

export default App;
